import React from 'react';
import './MeterReadingTarifPlain.less';
import { shortenObis } from '../../../helper/MeterHelper';

const MeterReadingTarifPlain = ({ obis, rateName }: { obis?: string; rateName?: string }) => {
    const shortObis = shortenObis(obis);

    if (!shortObis && !rateName) {
        return null;
    }

    // rateName = undefined;
    if (!rateName) {
        return <>{shortObis}</>;
    }

    return (
        <>
            {rateName} {shortObis ? `(${shortObis})` : ''}
        </>
    );
};

export default MeterReadingTarifPlain;
